import React from 'react';
import PropTypes from 'prop-types';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage } from 'react-intl';
import utils from '@/shared/utils/adminpulse';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import Checkbox from '@/shared/components/input/Checkbox';
import DateFormatService from '@/shared/services/DateFormatService';
import messages from '../jobMessages';

const JobDetailBatchFillDays = ({ job, intl }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);
  if (!parameters) return null;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.DateFrom} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                {DateFormatService.formatDate(parameters.dateFrom)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.DateUntil} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                {DateFormatService.formatDate(parameters.dateUntil)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Resource} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue list="resource" id={parameters.resourceId} fallback="" />
              </div>
            </div>
            {parameters.relationId === null ? (
              <div className="row">
                <div className="col-md-5 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.UseDefaultAbsenceRelationOfEmployee} />
                    </b>
                  </label>
                </div>
                <div className="col-md-7 col-sm-6">
                  <Checkbox value={true} onClick={() => 0} />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailBatchFillDays.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailBatchFillDays);
